import React from 'react';
import { Select, useMultipleSelect, Typography } from '@vtblife/uikit';
import { OptionType } from '@vtblife/uikit/legacy';

import { LandStatus } from '@search/filter-enums/enums';

import { MobileFilter2 } from '../../../filter/MobileFilter2';
import { LandStatusFilter } from '../../../../models/Filter';

interface IMobileLandStatusSelect {
    filter: LandStatusFilter;
    onChange: (filter: LandStatusFilter) => void;
}

enum FormattedLandStatus {
    LPH,
    SNT_DNP,
    IZHS
}

const OPTIONS: OptionType<FormattedLandStatus>[] = [
    { label: 'ЛПХ', value: FormattedLandStatus.LPH },
    { label: 'СНТ, ДНП', value: FormattedLandStatus.SNT_DNP },
    { label: 'ИЖС', value: FormattedLandStatus.IZHS }
];

function getValues(filter?: LandStatusFilter): FormattedLandStatus[] {
    const values: FormattedLandStatus[] = [];

    if (filter?.landStatuses.includes(LandStatus.IZHS)) {
        values.push(FormattedLandStatus.IZHS);
    }

    const isSntDnp = ! values.includes(FormattedLandStatus.SNT_DNP) &&
        (filter?.landStatuses.includes(LandStatus.SNT) || filter?.landStatuses.includes(LandStatus.DNP));

    if (isSntDnp) {
        values.push(FormattedLandStatus.SNT_DNP);
    }

    if (filter?.landStatuses.includes(LandStatus.AGRICULTURAL)) {
        values.push(FormattedLandStatus.LPH);
    }

    return values;
}

export const MobileLandStatusSelectFilter: React.FC<IMobileLandStatusSelect> = ({
    filter,
    onChange
}) => {
    const handleChange = React.useCallback((values: FormattedLandStatus[]) => {
        const res: LandStatus[] = [];

        values.forEach((value: FormattedLandStatus) => {
            if (value === FormattedLandStatus.IZHS) {
                res.push(LandStatus.IZHS);
                return;
            }
            if (value === FormattedLandStatus.LPH) {
                res.push(LandStatus.AGRICULTURAL);
            }
            if (value === FormattedLandStatus.SNT_DNP) {
                res.push(LandStatus.DNP);
                res.push(LandStatus.SNT);
            }
        });

        onChange(new LandStatusFilter(res));
    }, [ onChange ]);

    const values = getValues(filter);

    const {
        handleChange: handleChangeSelect,
        is,
        selectedText
    } = useMultipleSelect<FormattedLandStatus>(
        handleChange,
        {
            selected: values,
            texts: OPTIONS.map(({ label, value }) => ({ value, text: label }))
        }
    );

    return (
        <MobileFilter2 filterTitle='Статус участка'>
            <Select mode='multiple' onChange={handleChangeSelect}>
                <Select.Button size='s'>
                    {values.length > 0 ? selectedText : <Typography color='black-300'>Неважно</Typography>}
                </Select.Button>
                <Select.Content>
                    {OPTIONS.map(option => (
                        <Select.Option
                            key={option.value}
                            selected={is(option.value)}
                            value={option.value}
                        >
                            {option.label}
                        </Select.Option>
                    ))}
                </Select.Content>
            </Select>
        </MobileFilter2>
    );
};

